export const KNOWLEDGE_BASE_URL = 'https://help.hirasmus.com/knowledge';

export const KNOWLEDGE_BASE_ARTICLES = {
  IMPORT_PROGRAMS: `${KNOWLEDGE_BASE_URL}/import-programs-from-other-platforms`,
  IMPORT_CLIENTS: `${KNOWLEDGE_BASE_URL}/bulk-import-clients-from-spreadsheet`,
  IMPORT_USERS: `${KNOWLEDGE_BASE_URL}/bulk-import-users-from-a-file-0`,
  IMPORT_PROGRAM_DATA: `${KNOWLEDGE_BASE_URL}/importing-client-program-data`,
  NOTE_AUDITOR: `${KNOWLEDGE_BASE_URL}/ai-note-auditor-getting-started-guide`,
  LUMARY_SIGNATURE_MAPPING: `${KNOWLEDGE_BASE_URL}`
    + '/hi-rasmus-lumary-integration-how-to-set-up-caregiver/guardian-signature-mapping-to-sync-to-lumary',
};
